<template>
  <div class="publicMain">
    <el-row class="rightClass">
      <el-col :span="24" style="text-align: left;">
        <el-button type="primary" size="mini" @click="openDialog('add')">{{
          $t("common.addedBtn")
        }}</el-button>
        <el-button
          size="mini"
          :disabled="editDisabled"
          type="success"
          @click="openDialog('edit', multipleSelection[0])"
          >{{ $t("common.editBtn") }}</el-button
        >
        <el-button
          size="mini"
          :disabled="delDisabled"
          type="danger"
          @click="openDialog('del', multipleSelection)"
          >{{ $t("common.deleteBtn") }}</el-button
        >
        <!-- </el-col>
      <el-col :span="2" style="text-align: left;"> -->
        <!-- <label style="width: 100px;">{{ '公告等级' }}：</label> -->
        <el-select
          v-model="queryForm.ggdj"
          :placeholder="$t('gggl.noticelevel')"
          clearable
          size="mini"
          @change="getNoticeList('query')"
          style="padding-left: 10px; width: 100px;"
        >
          <el-option
            v-for="item in noticeOptions"
            :key="item.value[$i18n.locale]"
            :label="item.label[$i18n.locale]"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select
          v-model="queryForm.fbzt"
          :placeholder="$t('gggl.releasestatus')"
          clearable
          size="mini"
          @change="getNoticeList('query')"
          style="padding-left: 10px; width: 100px;"
        >
          <el-option
            v-for="item in yesOrNoOptions"
            :key="item.value[$i18n.locale]"
            :label="item.label[$i18n.locale]"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row>
      <el-table
        v-loading="tabLoading"
        :element-loading-text="$t('elTable.loadingText')"
        element-loading-spinner="el-icon-loading"
        :data="tableData"
        border
        style="width: 100%; font-size: 12px"
        :cellStyle="$store.state.cellStyle"
        :headerCellStyle="$store.state.headerCellStyle"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="50px"
          align="center"
        ></el-table-column>
        <el-table-column :label="$t('gggl.noticelevel')" width="100px" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.ggdj == '1'" size="small" type="info">{{
              $t('gggl.ordinary')
            }}</el-tag>
            <el-tag v-else size="small" type="danger">{{ $t('gggl.important') }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column :label="$t('gggl.noticecontent')" prop="ggnr"></el-table-column>
        <el-table-column
          :label="$t('gggl.releasestatus')"
          prop="fbzt"
          width="80px"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag
              type="info"
              size="mini"
              effect="dark"
              v-if="scope.row.fbzt == 0"
              >{{ $t("common.no") }}</el-tag
            >
            <el-tag
              type="success"
              size="mini"
              effect="dark"
              v-if="scope.row.fbzt == 1"
              >{{ $t("common.yes") }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('common.operation')"
          width="120px"
          align="center"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="openDialog('edit', scope.row)">
              <i class="el-icon-edit"></i>
              <span>{{ $t("common.editBtn") }}</span>
            </el-button>
            <el-button
              type="text"
              @click="openDialog('del', [scope.row])"
              style="color: #f56c6c;"
            >
              <i class="el-icon-delete"></i>
              {{ $t("common.deleteBtn") }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <!-- 分页组件 -->
      <Pagination
        :currentPage="currentPage"
        :total="total"
        :limit="limit"
        :small="true"
        :pageSizes="$store.state.pageSizes"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
    </el-row>

    <!--角色信息模态框-->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      @close="handleClose"
      top="20vh"
      width="500px"
    >
      <label slot="title">
        <i :class="dialogTitleIcon" style="font-size: 16px; font-weight: bold;">
          <span style="margin-right: 5px;">
            {{ this.dialogTitle }}
          </span>
        </i>
      </label>
      <el-card>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          :validate-on-rule-change="false"
          size="small"
        >
          <el-form-item :label="$t('gggl.noticelevel')" prop="ggdj">
            <el-select
              v-model="ruleForm.ggdj"
              :placeholder="$t('gggl.noticelevel')"
              clearable
              size="mini"
              style="width: 150px;"
            >
              <el-option
                v-for="item in noticeOptions"
                :key="item.value[$i18n.locale]"
                :label="item.label[$i18n.locale]"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('gggl.noticecontent')" prop="ggnr">
            <el-input
              type="textarea"
              v-model="ruleForm.ggnr"
              maxlength="300"
              show-word-limit
              :autosize="{ minRows: 3, maxRows: 6 }"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('gggl.releasestatus')" prop="fbzt">
            <el-switch
              class="fbztClass"
              v-model="ruleForm.fbzt"
              active-value="1"
              inactive-value="0"
              :active-text="$t('common.yes')"
              :inactive-text="$t('common.no')"
            >
            </el-switch>
          </el-form-item>
        </el-form>
      </el-card>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFormVisible = false">{{
          $t("common.cancelBtn")
        }}</el-button>
        <el-button
          type="primary"
          size="small"
          @click="submitForm('ruleForm')"
          >{{ $t("common.saveBtn") }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "gggl",
  computed: {
    rules() {
      // 模态框数据校验规则
      return {
        ggdj: [
          { required: true, message: "请选择公告等级", trigger: "blur" },
          { required: true, message: "请选择公告等级", trigger: "change" },
        ],
        ggnr: [{ required: true, message: "请输入公告内容", trigger: "blur" }],
      };
    },
  },
  data() {
    return {
      currentPage: 1, // 页码
      limit: this.$store.state.dataDisplayNum, // 分页显示条数
      total: 0, // 列表数据量
      pageSizes: this.$store.state.pageSizes, // 分页显示可选择条数
      queryForm: {
        ggdj: "",
        fbzt: "",
      },
      editDisabled: true, // 编辑按钮状态
      delDisabled: true, // 删除按钮状态
      multipleSelection: [], // 表格选中行
      noticeOptions: [], // 公告等级
      yesOrNoOptions: [], // 是否状态
      tableData: [],
      dialogFormVisible: false,
      dialogTitle: "", // 公告模态框标题
      dialogTitleIcon: "", // 公告模态框标题图标
      ruleForm: {
        ggdj: "",
        ggnr: "",
        fbzt: "1",
      },
      tabLoading: false, // 表格请求数据loading层
      saveFlg: "", // 保存操作区分
    };
  },
  methods: {
    /** 获取公告信息 */
    getNoticeList(flg) {
      let _this = this;
      if (flg == "query") {
        _this.queryForm.currentPage = 1;
        _this.queryForm.limit = _this.$store.state.dataDisplayNum;
        _this.currentPage = 1;
      } else {
        _this.queryForm.currentPage = _this.currentPage;
        _this.queryForm.limit = _this.limit;
      }
      _this.tabLoading = true;
      _this.$requestUtil.getNoticeList(_this.queryForm).then((tmpResult) => {
        _this.tabLoading = false;
        if (tmpResult.length > 0) {
          _this.total = parseInt(tmpResult[0].tableCount);
        } else {
          _this.total = 0;
        }
        _this.tableData = tmpResult;
        // _this.$store.commit('setSysNotice', _this.tableData);
      });
    },
    /** 打开模态框 */
    openDialog(flg, row) {
      if (flg == "add") {
        this.dialogFormVisible = true;
        this.$nextTick(() => {
          this.dialogTitle = this.$t('gggl.addnotice');
          this.dialogTitleIcon = "el-icon-document-add";
        });
      } else if (flg == "edit") {
        this.dialogFormVisible = true;
        this.$nextTick(() => {
          this.dialogTitle = this.$t('gggl.editnotice');
          this.dialogTitleIcon = "el-icon-edit-outline";
          this.ruleForm.id = row.id;
          this.ruleForm.ggdj = row.ggdj;
          this.ruleForm.ggnr = row.ggnr;
          this.ruleForm.fbzt = row.fbzt;
        });
      } else if (flg == "del") {
        let tmpArr = [];
        for (let tmp of row) {
          tmpArr.push(tmp.id);
        }
        this.delXtgl(tmpArr);
      }
      this.saveFlg = flg;
    },
    /** 保存模态框数据 */
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.saveFlg === "add") {
            this.addXtgl();
          } else if (this.saveFlg === "edit") {
            this.editXtgl();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    /** 添加系统公告 */
    addXtgl() {
      let _this = this;
      _this.$ajax
        .post("/api/xtglGggl/addXtgl", _this.ruleForm)
        .then(async (res) => {
          _this.dialogFormVisible = false;
          let msgCode = res.status;
          if (res.status == "200") {
            if (res.data.code == "200") {
              _this.$message.success("公告添加成功");
              await _this.getNoticeList("query");
              await _this.$requestUtil
                .getNoticeList({ currentPage: 0 })
                .then((tmpResult) => {
                  _this.$store.dispatch("setSysNotice", tmpResult);
                });
            }
          }
        })
        .catch((error) => {
          _this.dialogFormVisible = false;
        });
    },
    /** 编辑系统公告 */
    editXtgl() {
      let _this = this;
      _this.$ajax
        .post("/api/xtglGggl/updateXtgl", _this.ruleForm)
        .then(async (res) => {
          _this.dialogFormVisible = false;
          let msgCode = res.status;
          if (res.status == "200") {
            if (res.data.code == "200") {
              _this.$message.success("公告编辑成功");
              await _this.getNoticeList("query");
              await _this.$requestUtil
                .getNoticeList({ currentPage: 0 })
                .then((tmpResult) => {
                  _this.$store.dispatch("setSysNotice", tmpResult);
                });
            }
          }
        })
        .catch((error) => {
          _this.dialogFormVisible = false;
        });
    },
    /** 删除系统公告 */
    delXtgl(dataArr) {
      let _this = this;
      _this
        .$confirm(
          _this.$t("common.deleteContent"),
          _this.$t("common.deleteTitle"),
          {
            distinguishCancelAndClose: true,
            confirmButtonText: _this.$t("common.confirmBtn"),
            cancelButtonText: _this.$t("common.cancelBtn"),
          }
        )
        .then((res1) => {
          _this.$ajax
            .post("/api/xtglGggl/delXtgl", dataArr)
            .then(async (res) => {
              let msgCode = res.status;
              if (res.status == "200") {
                if (res.data.code == "200") {
                  _this.$message.success("删除成功");
                  await _this.getNoticeList("query");
                  await _this.$requestUtil
                    .getNoticeList({ currentPage: 0 })
                    .then((tmpResult) => {
                      _this.$store.dispatch("setSysNotice", tmpResult);
                    });
                }
              }
            });
        })
        .catch((action) => {
          // this.$message.info({
          //   message: action === 'cancel' ? '放弃保存并离开页面' : '停留在当前页面'
          // })
        });
    },
    handleClose(done) {
      this.$refs["ruleForm"].resetFields();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      if (this.multipleSelection.length == 1) {
        this.editDisabled = false;
      } else {
        this.editDisabled = true;
      }
      if (this.multipleSelection.length > 0) {
        this.delDisabled = false;
      } else {
        this.delDisabled = true;
      }
    },
    /** 页码改变时会触发 */
    handleCurrentChange(uniqueNum, val) {
      this.currentPage = val;
      this.getNoticeList();
    },
    /** 每页条数改变时触发 */
    handleSizeChange(uniqueNum, val) {
      this.limit = val;
      this.currentPage = 1;
      this.getNoticeList();
    },
  },
  mounted() {
    let _this = this;
    _this.getNoticeList();
    _this.$requestUtil
      .getCodeInfoById([
        "NORMAL_CODE_ANNOUNCEMENT",
        "NORMAL_CODE_YESORNO_STATE",
      ])
      .then((tmpResult) => {
        if (Object.keys(tmpResult).length > 0) {
          // 公告等级
          let noticeCodeList = tmpResult["NORMAL_CODE_ANNOUNCEMENT"];
          for (let tmp of noticeCodeList) {
            _this.noticeOptions.push({
              label: tmp.name,
              value: tmp.code,
            });
          }
          // 发布状态
          let yesOrNoCodeList = tmpResult["NORMAL_CODE_YESORNO_STATE"];
          for (let tmp of yesOrNoCodeList) {
            _this.yesOrNoOptions.push({
              label: tmp.name,
              value: tmp.code,
            });
          }
        }
      });
  },
};
</script>

<style lang="scss" scoped>
.rightClass {
  margin: 10px 0;
}
/* switch按钮样式 */
::v-deep .fbztClass {
  .el-switch__label--left {
    position: relative;
    left: 37px;
    margin-right: 0;
    color: #fff;
    z-index: -1111;
  }
  .el-switch__core {
    width: 50px !important;
  }
  .el-switch__label--right {
    position: relative;
    right: 37px;
    margin-left: 0;
    color: #fff;
    z-index: -1111;
  }
  .el-switch__label--right.is-active {
    z-index: 1111;
    color: #fff !important;
  }
  .el-switch__label--left.is-active {
    z-index: 1111;
    color: #9c9c9c !important;
  }
}
</style>
